import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Waves_ds_pick_waves_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerIds?: number[], projectIds?: number[], warehouseIds?: number[], statusIds: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, dateType?: string }): 
  Promise<{ result: { Id?: number, BatchPick?: boolean, CreatedSysDateTime?: string, CreatedSysUser?: string, Description?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, ReleaseDate?: string, StagingLocationId?: number, WarehouseId?: number, Priority?: { Id?: number, Description?: string, Name?: string, Value?: number }, Status?: { Id?: number, Name?: string }, Shipments?: { Id?: number, OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { Id?: number, OrderClassId?: number, Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, OrderClass?: { Id?: number, Name?: string, OrderClassTypeId?: number, OrderTypeId?: number } } }[] }[], Warehouse?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.statusIds)) {
      missingRequiredInParams.push('\'statusIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Waves/datasources/ds_pick_waves_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerIds?: number[], projectIds?: number[], warehouseIds?: number[], statusIds: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, dateType?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, BatchPick?: boolean, CreatedSysDateTime?: string, CreatedSysUser?: string, Description?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, ReleaseDate?: string, StagingLocationId?: number, WarehouseId?: number, Priority?: { Id?: number, Description?: string, Name?: string, Value?: number }, Status?: { Id?: number, Name?: string }, Shipments?: { Id?: number, OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { Id?: number, OrderClassId?: number, Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, OrderClass?: { Id?: number, Name?: string, OrderClassTypeId?: number, OrderTypeId?: number } } }[] }[], Warehouse?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.statusIds)) {
      missingRequiredInParams.push('\'statusIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Waves/datasources/ds_pick_waves_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerIds?: number[], projectIds?: number[], warehouseIds?: number[], statusIds: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, dateType?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, BatchPick?: boolean, CreatedSysDateTime?: string, CreatedSysUser?: string, Description?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, ReleaseDate?: string, StagingLocationId?: number, WarehouseId?: number, Priority?: { Id?: number, Description?: string, Name?: string, Value?: number }, Status?: { Id?: number, Name?: string }, Shipments?: { Id?: number, OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { Id?: number, OrderClassId?: number, Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, OrderClass?: { Id?: number, Name?: string, OrderClassTypeId?: number, OrderTypeId?: number } } }[] }[], Warehouse?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.statusIds)) {
      missingRequiredInParams.push('\'statusIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Waves/datasources/ds_pick_waves_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerIds?: number[], projectIds?: number[], warehouseIds?: number[], statusIds: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, dateType?: string    }) {
        if(isNil(inParams.statusIds)) {
          return true; 
        }
      return false;
    }
}
